import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';
import { useThemeColors } from '../hooks/useThemeColors';

interface ChartProps<T extends object> {
  data: T[];
  dataKey: keyof T & string;
  xAxisKey: keyof T & string;
  height?: number;
}

export function Chart<T extends object>({ data, dataKey, xAxisKey, height = 300 }: ChartProps<T>) {
  const c = useThemeColors();
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={c.grid} />
        <XAxis
          dataKey={xAxisKey}
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 12, fill: c.axis }}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 12, fill: c.axis }}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: c.tooltipBg,
            border: `1px solid ${c.tooltipBorder}`,
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
          }}
          labelStyle={{ color: c.tooltipLabel, fontWeight: 500 }}
        />
        <Line
          type="monotone"
          dataKey={dataKey}
          stroke={c.line}
          strokeWidth={2}
          dot={{ fill: c.line, strokeWidth: 2, r: 4 }}
          activeDot={{ r: 6, fill: c.line }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
